import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/use-auth";
import { playNotificationSound } from "@/lib/notification-sound";

/**
 * Plays a chime whenever a chat message from someone else arrives,
 * no matter which page the user is on. RLS limits realtime rows to
 * conversations the current user belongs to.
 */
export function GlobalMessageSound() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const channel = supabase
      .channel("global-message-sound")
      .on(
        "postgres_changes",
        { event: "INSERT", schema: "public", table: "messages" },
        (payload) => {
          const row = payload.new as { sender_id?: string };
          if (row?.sender_id && row.sender_id !== user.id) {
            playNotificationSound();
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user]);

  return null;
}
